var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5339 0C3.82076 0 0 3.82061 0 8.53357C0 13.2465 3.82076 17.0671 8.5339 17.0671C10.6779 17.0671 12.6372 16.2765 14.1362 14.971L18.8013 19.7877C19.0693 20.0645 19.511 20.0715 19.7877 19.8035C20.0645 19.5355 20.0715 19.0939 19.8035 18.8171L15.1108 13.9718C16.3332 12.4952 17.0678 10.6002 17.0678 8.53357C17.0678 3.82061 13.247 0 8.5339 0ZM1.3952 8.53357C1.3952 4.59112 4.5913 1.39514 8.5339 1.39514C12.4765 1.39514 15.6726 4.59112 15.6726 8.53357C15.6726 12.476 12.4765 15.672 8.5339 15.672C4.5913 15.672 1.3952 12.476 1.3952 8.53357Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "search.d8df27a950c805031f84fd53d5c2689c.svg";